 export enum ReviewStatus {
  REPLIED = 'replied',
  NOT_REPLIED = 'not_replied'
}

export enum StarRating {
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5
}

export interface Review {
  id: string;
  userName: string;
  userInitial: string;
  message: string;
  rating: StarRating;
  date: Date;
  status: ReviewStatus;
  hasMore: boolean;
  raw?: any; 
}

export interface ReviewsStats {
  totalReviews: number;
  averageRating: number;
  ratingDistribution: Record<number, number>;
}

export interface ChartDataPoint {
  date: Date;
  reviews: number;
}

 export interface ReviewsPageProps {
  LocationId: string;
  LocationName: string;
}

export interface ReviewsData {
  totalReviews: number;
  averageRating: number;
  ratingDistribution: Record<number, number>;
  chartData: ChartDataPoint[];
  reviews: Review[];
}